import { InjectionToken, Signal, signal } from '@angular/core';

/**
 * The locale every picker reads unless its own `locale` input names another one. `ui-kit`
 * is tagged `type:ui` and may not import a service, so the app provides this instead —
 * `provideDatePickerLocale()` in shared-lib.
 *
 * Unset is `en-US`, never the browser's tag: only the user's own language decides the
 * format, or a Canadian browser turns an English user's dates into ISO.
 */
export const DATE_PICKER_LOCALE = new InjectionToken<Signal<string | null>>('DATE_PICKER_LOCALE', {
  providedIn: 'root',
  factory: () => signal<string | null>(null).asReadonly(),
});
